import {
  StudentLimitedResponse,
  TutorAdminResponse,
  TutorStudentsService,
} from "client/openapi";
import AssignedPeople from "pages/manage/ProfilePageResources/AssignedPeople";
import { BackpackIcon } from "@radix-ui/react-icons";

/** The tutor's students, with Assign Student to pair another. */
export default function Students({
  tutor,
  orgStudents,
}: {
  tutor: TutorAdminResponse;
  orgStudents: StudentLimitedResponse[];
}) {
  return (
    <AssignedPeople
      id="student-students"
      title="Students"
      icon={<BackpackIcon />}
      noun="Student"
      assigned={tutor.students}
      candidates={orgStudents}
      viewPath={(student) => `/manage/students/${student.id}`}
      assign={(student) =>
        TutorStudentsService.createTutorStudentRelationship({
          tutorId: tutor.id,
          studentId: student.id,
        })
      }
      remove={(student) =>
        TutorStudentsService.removeTutorStudentRelation({
          tutorId: tutor.id,
          studentId: student.id,
        })
      }
    />
  );
}
